import Auth from '@aws-amplify/auth'
import Amplify from '@aws-amplify/core'
import _ from 'lodash';

const Logger = Amplify.Logger
Logger.LOG_LEVEL = 'INFO'
const logger = new Logger('store:auth')

export interface IAuthToken {
  access: string;
  id: string;
}

const getters = {
    //AUTHENTICATEDUSER: () => Auth.currentAuthenticatedUser(),
    //AUTHINFO: () => Auth.currentUserInfo(),
    /*AUTHUSERNAME: () => {
      return Auth.currentUserInfo().then ( res => {
        return res.username
      })
    },
    ISAUTHENTICATED: () => {
      const r = Auth.currentAuthenticatedUser().then( res => {
        const s = _.isString(_.get(res, 'signInUserSession.accessToken.jwtToken')) 
        return s
      })
      return r
    },*/
    /*AUTHENTICATIONTOKEN: () => {
      return Auth.currentAuthenticatedUser().then( (res) => {
        return {
          access: _.get(res, 'signInUserSession.accessToken.jwtToken'),
          id: _.get(res, 'signInUserSession.idToken.jwtToken')
        } as IAuthToken
      }).catch(err => {
        return {
          access: '',
          id: ''
        } as IAuthToken
      })
    }*/
}

const mutations = {
    
}

const actions = {
    
}

export default {
    getters,
    actions,
    mutations
}